import script from "./cameraPage.vue?vue&type=script&setup=true&lang=js"
export * from "./cameraPage.vue?vue&type=script&setup=true&lang=js"

import "./cameraPage.vue?vue&type=style&index=0&id=54cdb50a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cdb50a"]])

export default __exports__